var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaintainVehicle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 30.5,
    fill: "#fff",
    stroke: "#3C3C3C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#maintain-vehicle_svg__clip0_23940_40125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.134 25.195v-1.093H11.297v1.093h10.837zM49.573 25.195v-1.093H38.737v1.093h10.836z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3 20.324h-1.853c-.718 0-1.3.583-1.3 1.301v6.842c0 .719.582 1.301 1.3 1.301H17.3c.719 0 1.301-.582 1.301-1.3v-6.843c0-.718-.582-1.3-1.3-1.3zM46.523 20.324H44.67c-.718 0-1.3.583-1.3 1.301v6.842c0 .719.582 1.301 1.3 1.301h1.853c.718 0 1.3-.582 1.3-1.3v-6.843c0-.718-.582-1.3-1.3-1.3z",
    fill: "#303133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.349 27.452H17.055a2.033 2.033 0 01-2.002-1.67l-1.082-5.952a7.208 7.208 0 012.545-6.884l2.134-4.59a3.038 3.038 0 012.745-1.752h15.939c.847 0 1.66.358 2.233.984l3.92 4.283a9.707 9.707 0 014.248 8.726l-.358 4.967a2.042 2.042 0 01-2.028 1.888z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.52 12.529H19.142a1.09 1.09 0 01-.916-.497 1.09 1.09 0 01-.084-1.04l1.127-2.547c.171-.387.556-.643.98-.65l18.222.022c.347-.003.679.154.889.428l2.027 2.526c.255.332.297.773.112 1.148-.186.376-.561.61-.98.61zM43.725 19.255a1.871 1.871 0 100-3.742 1.871 1.871 0 000 3.742zM19.136 19.255a1.871 1.871 0 100-3.742 1.871 1.871 0 000 3.742z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9 24.378H21.496v-.044c0-1.057.86-1.916 1.916-1.916h16.57c1.057 0 1.916.86 1.916 1.916v.044z",
    fill: "#303133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.816 13.338a.516.516 0 01-.314-.106l-.747-.57a.43.43 0 00-.26-.089h-1.631a.512.512 0 01-.448-.258.512.512 0 010-.516l.397-.694a.52.52 0 01.38-.255l2.041-.272a.514.514 0 01.564.366l.513 1.73a.52.52 0 01-.495.665zM43.283 12.982a.517.517 0 01-.495-.664l.513-1.73c.072-.247.31-.4.564-.366l2.04.272a.52.52 0 01.38.255l.399.694a.511.511 0 01-.001.516.512.512 0 01-.447.258h-1.632a.43.43 0 00-.26.088l-.747.571a.516.516 0 01-.314.106zM12.39 9.984h-1.093v42h1.093v-42zM50.17 9.984h-1.094v42h1.094v-42z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.207 35.883l-1.274-2.743a1.54 1.54 0 01.746-2.04l2.2-1.022a4.493 4.493 0 00-3.782.003 4.504 4.504 0 00-2.517 4.968l-15.755 7.316c-.04.018-.074.042-.11.065a4.504 4.504 0 00-7.764 1.253l1.982-.92a1.54 1.54 0 012.04.746l1.273 2.743a1.54 1.54 0 01-.746 2.04l-2.2 1.021a4.493 4.493 0 003.782-.003 4.504 4.504 0 002.514-4.98c.041-.014.082-.024.122-.042l15.755-7.316a4.504 4.504 0 007.755-1.263l-1.982.92a1.54 1.54 0 01-2.04-.746z",
    fill: "#E95832"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "maintain-vehicle_svg__clip0_23940_40125"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(3.5 6.604)",
    d: "M0 0h52v48.97H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/maintain-vehicle.3037e315.svg";
export { SvgMaintainVehicle as ReactComponent };